import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Layout } from '@/components/layout/Layout';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { useOrderStore } from '@/stores/orderStore';
import { identifyUser } from '@/utils/analytics';

// Route components (migrated from views)
import {
  AddressEntryView,
  ServiceAvailableView,
  // PropertyConfirmationView, // RETIRED (Sep 2026): RentCast
  PersonalInfoView,
  UtilitiesSelectionView,
  PlanOptionsView,
  ServiceSetupView,
  DocumentUploadView,
  OrderConfirmationView,
} from '@/views';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  const userId = useOrderStore((state) => state.userId);

  useEffect(() => {
    if (userId) {
      identifyUser(userId);
    }
  }, [userId]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ScrollToTop />
        <ErrorBoundary>
          <Layout>
            <Routes>
              <Route path="/" element={<AddressEntryView />} />
              <Route path="/service-available" element={<ProtectedRoute><ServiceAvailableView /></ProtectedRoute>} />
              {/* RETIRED (Sep 2026): RentCast property confirmation screen */}
              {/* <Route path="/property" element={<ProtectedRoute><PropertyConfirmationView /></ProtectedRoute>} /> */}
              <Route path="/personal-info" element={<ProtectedRoute><PersonalInfoView /></ProtectedRoute>} />
              <Route path="/utilities" element={<ProtectedRoute><UtilitiesSelectionView /></ProtectedRoute>} />
              <Route path="/plan-options/:planId" element={<ProtectedRoute><PlanOptionsView /></ProtectedRoute>} />
              <Route path="/checkout" element={<ProtectedRoute><ServiceSetupView /></ProtectedRoute>} />
              <Route path="/documents" element={<ProtectedRoute><DocumentUploadView /></ProtectedRoute>} />
              <Route path="/confirmation" element={<OrderConfirmationView />} />
            </Routes>
          </Layout>
        </ErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
